<h2 mat-dialog-title class="titulo">{{ titulo }}</h2>

<div mat-dialog-content #datos>
    <p class="info">Para firmar necesitamos validar tus datos. Ingresa RUT y código identificador de seguridad enviado a su correo.</p>
    <form autocomplete="off" [formGroup]="form">
        <mat-label class="inputTitle">RUT</mat-label>
        <mat-form-field [style.width.%]="100" appearance="outline">
            <input matInput type="text" formControlName="rut" placeholder="Ingresa RUT"  (keyup)="formatoRUT($event)" [value]="rut" maxlength="10" [class.is-invalid]="rutNoValido" cdkFocusInitial>
        </mat-form-field>
        <mat-label class="inputMsj">Formato: sin puntos con guión. Ejemplo: 12345678-9</mat-label>

        <mat-label class="inputTitle">Identificador de seguridad</mat-label>
        <mat-form-field [style.width.%]="100" appearance="outline">
            <input matInput type="text" formControlName="token" placeholder="Ingresa Identificador" [class.is-invalid]="tokenNoValido">
        </mat-form-field>
        <mat-label class="inputMsj">Ingresa el identificador de seguridad que llegó a tu email</mat-label>
    </form>
</div>

<div mat-dialog-content class="ocultar" #error>
    <div class="icon-text">
        <mat-icon aria-hidden="false" aria-label="home icon">warning_amber</mat-icon>
    </div>    
    <p class="parrafo">
        Validación de datos errónea. Verifica que los datos estén correctos para firmar el documento.
    </p>
    <div align="end">
        <button type="submit" mat-button class="btnVolver" (click)="volver()">Volver</button>
    </div>
</div>

<div mat-dialog-content class="ocultar" #firmar>
    <p style="text-align: justify;">
        Al <strong>firmar</strong> el documento, declaras estar en conocimiento y de acuerdo con el contenido del mismo.
    </p>
    <div align="end">
        <button type="submit" mat-button class="btnCancelar" (click)="salir()">Cancelar</button>
        <button type="submit" mat-button class="btnFirmar" (click)="firmarDocumento()">Firmar Documento</button>
    </div>
</div>

<div mat-dialog-actions align="end" #action>
    <button type="submit" mat-button class="btnCancelar" (click)="salir()">Cancelar</button>
    <button type="submit" mat-button class="btnValidar" (click)="validar()" [disabled]="form.invalid">Validar</button>
</div>